﻿import React from "react";
import { useLocation, useNavigate, UNSAFE_NavigationContext} from "react-router-dom";
import { Modal } from "../layout";
import { useRouterPrompt } from "./RouterPrompt";

export interface RouterPromptModalProps {
  block: boolean;
}

export const RouterPromptModal = (props: RouterPromptModalProps) => {
  const context = React.useContext(UNSAFE_NavigationContext);
  if(!context) {
    return <></>
  }

  const navigation = useNavigate();
  const location = useLocation();

  const [showPrompt, confirmNavigation, cancelNavigation] = useRouterPrompt(
    navigation,
    location,
    props.block
  );

  return (
    <Modal
      id="unsaved-changes-prompt"
      title="Are you sure you want to leave the page?"
      open={showPrompt}
      onClose={() => { }}
      onOpened={() => { }}
      leftButtons={[
        {
          label: 'OK',
          mode: 'secondary',
          onClick: () => {
            confirmNavigation();
          }
        }
      ]}
      rightButtons={[
        {
          label: 'Cancel',
          mode: 'secondary',
          onClick: () => {
            cancelNavigation();
          }
        }
      ]}>
      <span>
        Changes you have made to the form will not be saved. Please save your changes before moving away from this page.
      </span>
    </Modal>
  );
}